import React from 'react';
import {checkAnswer} from './lib/money';

export default class AnswerEntry extends React.Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleNewProblemButtonClick = this.handleNewProblemButtonClick.bind(this);
    AnswerEntry.propTypes = {
      updateStats: React.PropTypes.func,
      createNewProblem: React.PropTypes.func
    };
  }

  handleSubmit(event){
    var answerCorrect = checkAnswer(this.props.gameState, this.refs.answerInput.value);
    this.props.updateStats(answerCorrect);
    event.preventDefault();
  }

  handleNewProblemButtonClick(){
    this.refs.answerInput.value = '';
    this.props.createNewProblem();
  }

  render() {
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <span className="answer-entry__dollar-sign">$</span>
          <input 
            className="answer-entry__input" 
            type="text" 
            ref="answerInput" 
            placeholder="0.00"
            maxLength="4"
          />
        </form>
        <button 
          type="button" 
          className="edge-button edge-button--secondary answer-entry__new-problem" 
          onClick={this.handleNewProblemButtonClick}>New Problem
        </button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/money/answer-entry.js
 **/